import { LocTagInvite } from 'src/types/LineOfCredit';
import { transformPenniesToDollar } from 'src/utilities/currency-utils';

export interface GroupFormFields {
  id: string;
  name: string;
  budget: string;
}

export const defaultGroupFormValues: GroupFormFields = {
  id: '',
  name: '',
  budget: '',
};

// Generate default form values based on initGroup
export function getDefaultGroupFormValues(
  initGroup: LocTagInvite | undefined
): GroupFormFields {
  if (!initGroup) {
    return defaultGroupFormValues;
  }

  const { id, name, budget } = initGroup;

  return {
    id,
    name,
    budget: transformPenniesToDollar(budget),
  };
}
